<script>
    import { changeData } from '@/scripts/tools.js';

    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            addData() {return this.$store.getters.FILTER_ITEM_DATA_ADD},
            assetType() {return this.$store.getters.ASSET_TYPES},
            filterNoParent() {return this.$store.getters.FILTER_PARENT_FILTER(this.addData['asset_type_id'], false)},
        },
        async mounted() {
            await this.defaultValue();
        },
        methods: {
            async defaultValue() {
                if (this.addData.asset_type_id == null || this.addData.asset_type_id < 1) {
                    this.$store.commit('FILTER_ITEM_DATA_ADD_UPDATE', {
                        fieldName: 'asset_type_id',
                        fieldValue: this.$store.getters.ASSET_TYPE_IMAGES,
                    })
                }
            },
            async updateData(event, fieldName, isCheckBox = false) {
                this.errorText = await changeData(
                    event, fieldName, 'FILTER_ITEM_DATA_ADD_UPDATE', 'CHECK_FILTER_ITEM_ADD', isCheckBox
                );
            },
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input
            class="right_input mt_5 mb_10" 
            type="text"
            :value="addData['name']"
            @change="updateData($event, 'name')"
        >

        <label>Asset Type:</label>
        <select
            class="right_input mt_5 mb_10"
            :value="addData['asset_type_id']"
            @change="updateData($event, 'asset_type_id')"
        >
            <option
                v-for="(assetTypeValue, assetTypeIndex) in assetType" :key="assetTypeIndex"
                :value="assetTypeValue['id']"
            >
                {{ assetTypeValue['name'] }}
            </option>
        </select>
        
        <label>Filter:</label>
        <select
            class="right_input mt_5 mb_10"
            :value="addData['filter_id']"
            @change="updateData($event, 'filter_id')"
        >
            <option>None</option>
            <option
                v-for="(filterValue, filterIndex) in filterNoParent" :key="filterIndex"
                :value="filterValue['id']"
            >
                {{ filterValue['name'] }}
            </option>
        </select>
        
        <label class="mb_10">
            <input 
                type="checkbox"
                :checked="addData['is_default']"
                @change="updateData($event, 'is_default', true)"
            >
            Default
        </label>

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>